import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Pie,

  mixins: [reactiveProp],

  props: {
    showLegend: {
      type: Boolean,
      default: false
    },

    legendPosition: {
      type: String,
      default: "top",
      validator: function(value) {
        // The value must match one of these strings
        return ["bottom", "top", "left", "right"].includes(value);
      }
    },

    legendFontSize: {
      default: 24,
      required: false
    }
  },

  data() {
    return {
      options: {
        legend: {
          display: this.showLegend,
          position: this.legendPosition,
          labels: {
            fontFamily: "Manrope, Lato, sans-serif",
            fontSize: this.legendFontSize
          }
        }
      }
    };
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
